import React from "react";
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NearMeIcon from '@mui/icons-material/NearMe';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

import RequestEventDate from '../../dialogs/RequestEventDate';

import latestNews from '../../db/latestNews.json';


export default function LatestNews(props) {
	const { t, i18n } = useTranslation("",{lng: props.language});
	const [requestDate, setRequestDate] = React.useState(false);
	const [event, setEvent] = React.useState();

  	return (<>
				<Box style={{	background: "rgba(100,100,100,.5)", 					  			
					  			display: "inline-block", 
					  			padding: "10px", 
					  			borderRadius: "5px"
					  		}}
					 >
					<Swiper	direction= 'vertical'
							slidesPerView={1}
					        spaceBetween={30}
					        freeMode={true}
					        pagination={{
					          clickable: true,
					        }}
					        modules={[FreeMode, Pagination]}
					        className="myNewsHeader"
					        style={{height: "210px",width: "350px"}}
					      >
							{latestNews.map((news) => (
					        	<SwiperSlide>
									<Box style={{display: "inline-block", width: "300px"}}>
										<h2 style={{color: "#fff", marginTop: "0px", marginBottom: "0px"}}><b>{news.headline}</b></h2>
										<h2 style={{color: "#fff", marginTop: "10px"}}>{news.slogan}</h2>
										<h2 style={{color: "#fff", fontSize: "1.em"}}><NearMeIcon />&nbsp;{news.location}</h2>
										<Button variant="contained"
												endIcon={<CalendarMonthIcon/>}
												onClick={e => {setRequestDate(true); setEvent(news)}}
										>
											{news.buttonlabel}
										</Button>
									</Box>
					        	</SwiperSlide>
					        ))}

					</Swiper>					
				</Box>
				<RequestEventDate open={requestDate} handleOpen={setRequestDate} event={event}/>
			</>
	  )
}